import { Link } from 'react-router-dom';

const products = [
  {
    name: 'Camisetas Personalizadas',
    category: 'Textiles',
    image: 'https://public.readdy.ai/ai/img_res/2d9f129192d506b59be9d6679eb0039e.jpg',
  },
  {
    name: 'Hoodies Premium',
    category: 'Textiles',
    image: 'https://readdy.ai/api/search-image?query=custom%20hoodie%20sweatshirt%20with%20sublimation%20print%2C%20professional%20product%20photography%2C%20clean%20white%20background%2C%20premium%20quality%20apparel&width=600&height=700&seq=prod002&orientation=portrait',
  },
  {
    name: 'Gorras Bordadas',
    category: 'Accesorios',
    image: 'https://readdy.ai/api/search-image?query=custom%20embroidered%20baseball%20cap%20hat%20with%20logo%2C%20professional%20product%20photography%2C%20clean%20white%20background%2C%20premium%20quality%20headwear&width=600&height=700&seq=prod003&orientation=portrait',
  },
  {
    name: 'Tazas Sublimadas',
    category: 'Drinkware',
    image: 'https://readdy.ai/api/search-image?query=custom%20sublimation%20printed%20ceramic%20mug%20with%20colorful%20design%2C%20professional%20product%20photography%2C%20clean%20white%20background%2C%20high%20quality%20drinkware&width=600&height=700&seq=prod004&orientation=portrait',
  },
  {
    name: 'Botellas Personalizadas',
    category: 'Drinkware',
    image: 'https://readdy.ai/api/search-image?query=custom%20printed%20water%20bottle%20tumbler%20with%20logo%20design%2C%20professional%20product%20photography%2C%20clean%20white%20background%2C%20premium%20quality%20drinkware&width=600&height=700&seq=prod005&orientation=portrait',
  },
  {
    name: 'Artículos Promocionales',
    category: 'Promocionales',
    image: 'https://readdy.ai/api/search-image?query=custom%20promotional%20items%20branded%20merchandise%20collection%20pens%20notebooks%20bags%2C%20professional%20product%20photography%2C%20clean%20white%20background%2C%20corporate%20gifts&width=600&height=700&seq=prod006&orientation=portrait',
  },
];

const ProductsPreview = () => {
  return (
    <section className="py-24 bg-[#F8F9FA]" id="productos">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-[#FF6B35] text-sm font-semibold uppercase tracking-widest">Catálogo</span>
          <h2 className="text-3xl md:text-5xl font-extrabold text-[#0A1628] mt-3 mb-4">
            Productos que Transforman tu Marca
          </h2>
          <p className="text-[#6C757D] text-lg max-w-2xl mx-auto">
            Desde prendas hasta artículos promocionales, personalizamos todo con la más alta calidad.
          </p>
          <div className="w-16 h-1 bg-[#FF6B35] rounded-full mx-auto mt-6"></div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {products.map((product) => (
            <div
              key={product.name}
              className="group bg-white rounded-2xl overflow-hidden border border-[#E5E5E5] hover:border-[#FF6B35]/30 transition-all duration-300"
              data-product-shop
            >
              {/* Image */}
              <div className="relative overflow-hidden h-64">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="bg-[#0A1628]/80 text-white text-xs font-medium px-3 py-1 rounded-full">
                    {product.category}
                  </span>
                </div>
              </div>

              {/* Info */}
              <div className="p-5 flex items-center justify-between">
                <h3 className="text-[#0A1628] font-bold text-base">{product.name}</h3>
                <Link
                  to="/productos"
                  className="inline-flex items-center gap-1 text-[#FF6B35] text-sm font-semibold whitespace-nowrap cursor-pointer hover:gap-2 transition-all"
                >
                  Cotizar
                  <i className="ri-arrow-right-line text-sm"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* View All */}
        <div className="text-center mt-12">
          <Link
            to="/productos"
            className="inline-flex items-center gap-2 border-2 border-[#0A1628] text-[#0A1628] font-bold px-8 py-4 rounded-full whitespace-nowrap cursor-pointer hover:bg-[#0A1628] hover:text-white transition-all duration-200"
          >
            Ver Catálogo Completo
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ProductsPreview;
